import * as React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, Typography, DialogActions, Tabs, Tab } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationRoom, reservationSlot, reservation, contactReservationResonse, emptyReservation, reservationResponse } from '../../../../model/reservation'
import moment from 'moment';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import { contact } from '../../../../model/contact';
import ReservationSlotAdd from './ReservationSlotAdd';
import ReservationSlotUserList from './ReservationSlotUserTable';
import ReservationSlotResponse from './ReservationSlotResponse';
import { Alert, AlertTitle } from '@material-ui/lab';
import UndoButton from '../../../../ui-components/Button/UndoButton';

interface IProps extends IMediaQueryProps, IInnerProps {

}

interface IInnerProps extends StyledComponentProps {
    onConfirm: (reservation: reservation) => any;
    onDeleteReservation: (reservationId: string, userId: string) => any;
    onCancel: () => any;
    reservationSlot?: reservationSlot;
    reservationRoom?: reservationRoom;
    reservations: contactReservationResonse[];
    loadingReservations: boolean;
    addInProgress: boolean;
    deleteInProgress: boolean;
    reloadSlotDetail: () => void;
    resetResponseState: () => void;
    reservationResponse: reservationResponse;
    open: boolean;
}
interface IState {
    selectedTab: string;
    newReservation: reservation;
    selectedUserReservation?: contact;
    selectedUserToDelete?: contactReservationResonse;
    userPage: number;
}


class ReservationSlotDetailDialog extends React.Component<IProps, IState> {

    /**
     *
     */
    constructor(p, c) {
        super(p, c);
        this.state = {
            selectedTab: "list",
            newReservation: emptyReservation(),
            selectedUserReservation: undefined,
            selectedUserToDelete: undefined,
            userPage: 0,
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (!prevProps.open && this.props.open) {
            this.setState({
                selectedTab: "list",
                newReservation: emptyReservation(),
                selectedUserReservation: undefined,
                selectedUserToDelete: undefined,
                userPage: 0,
            })
        }
    }

    OkIconButton = () => {
        return <ConfirmButton disabled={(this.state.selectedUserReservation ? false : true) || this.props.addInProgress}
            onClick={() => this.props.onConfirm(this.state.newReservation)} text={"Prenota"} />
    }

    CloseIconButton = () => {
        return <CancelButton disabled={this.props.addInProgress} onClick={this.props.onCancel} />
    }

    handleTabChange = (e, tab) => {
        if (tab === "list" && this.state.selectedTab !== "list") {
            this.props.reloadSlotDetail();
        }
        if (this.props.reservationResponse) {
            this.props.resetResponseState();
        }
        this.setState({
            selectedTab: tab
        })
    }

    updateReservationToAdd = (reservation: reservation, selectedUser: contact) => {
        this.setState({
            newReservation: reservation,
            selectedUserReservation: selectedUser
        })
    }

    updateUserPage = (newPage: number) => {
        this.setState({
            userPage: newPage,
        })
    }
    setUserReservationToDelete = (user: contactReservationResonse) => {
        if (this.props.reservationResponse) {
            this.props.resetResponseState();
        }
        this.setState({
            selectedUserToDelete: user,
        })
    }

    getUserReservationLabel = (user: contactReservationResonse) => {
        return user.surname ? user.surname + " " + user.name : user.email;
    }

    checkResponse = () => {
        if (this.props.reservationResponse && this.props.reservationResponse.result && this.state.selectedUserToDelete) {
            this.setState({
                selectedUserToDelete: undefined,
            })
        }
    }


    render() {
        let disabled = this.props.addInProgress || this.props.deleteInProgress;
        let startTime = this.props.reservationSlot ? moment(this.props.reservationSlot.startingTime) : moment();
        let endTime = this.props.reservationSlot ? moment(this.props.reservationSlot.startingTime).add(this.props.reservationSlot.stayingMinutes, "minute") : moment();
        // let readOnly = this.props.reservationSlot.capacity - this.props.reservations.length <= 0 || moment().isSameOrBefore(startTime);
        this.checkResponse();
        return (
            <Dialog
                open={this.props.open}
                onClose={(e) => this.props.addInProgress ? {} : this.props.onCancel()}
                maxWidth={"lg"}
                classes={{
                    paper: this.props.classes.ReservationDialog
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {<DialogTitle id="alert-dialog-title">Dettaglio Slot {startTime.format("DD dddd 'MMMM")} {startTime.format("HH:mm")} - {endTime.format("HH:mm")}</DialogTitle>}
                < DialogContent className={this.props.classes.reservationSlotDetailDialogContent} >
                    {this.props.reservationSlot && <Grid style={{ width: "100%" }}>
                        <Tabs indicatorColor="primary"
                            disabled={disabled}
                            classes={{
                                root: this.props.classes.tabsFullWith
                            }}
                            variant="fullWidth"
                            value={this.state.selectedTab}
                            onChange={this.handleTabChange}
                            aria-label="tab-reservation-slot-detail">
                            <Tab label="Prenotazioni" value={"list"} disabled={disabled} />
                            <Tab label="Aggiungi Prenotazione" value={"add"} disabled={disabled || this.props.reservationSlot.capacity - this.props.reservations.length <= 0} />
                        </Tabs>
                        <Grid style={{ width: "100%" }}>
                            {this.state.selectedTab === "list" ?
                                <Grid style={{ width: "100%" }}>
                                    <Grid item xs={12} className={this.props.classes.ReservationSlotInfoContainer}>
                                        <Typography className={this.props.classes.Typography}>Posti Liberi: {this.props.reservationSlot.capacity - this.props.reservations.length}/{this.props.reservationSlot.capacity}</Typography>
                                    </Grid>
                                    <ReservationSlotUserList
                                        classes={this.props.classes}
                                        page={this.state.userPage}
                                        updatePage={this.updateUserPage}
                                        setUserReservationToDelete={this.setUserReservationToDelete}
                                        loadingReservations={this.props.loadingReservations}
                                        reservations={this.props.reservations} />
                                    {this.state.selectedUserToDelete &&
                                        <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                            <Alert severity="warning" >
                                                <AlertTitle>Elimina Prenotazione</AlertTitle>
                                            Stai per eliminare la prenotazione di {this.getUserReservationLabel(this.state.selectedUserToDelete)}, vuoi procedere ?
                                        </Alert>
                                            <Grid container style={{ justifyContent: "center", padding: "10px" }}>
                                                <ConfirmButton className={this.props.classes.deleteConfirmButton}
                                                    disabled={disabled}
                                                    onClick={() => this.props.onDeleteReservation(this.state.selectedUserToDelete.reservationId, this.state.selectedUserToDelete.sub)} text={"Elimina"} />
                                                <UndoButton disabled={disabled} onClick={() => this.setUserReservationToDelete(undefined)} text={"Annulla"} />
                                            </Grid>
                                        </Grid>}
                                </Grid>
                                :
                                <Grid style={{ width: "100%" }}>
                                    <ReservationSlotAdd
                                        reservationSlot={this.props.reservationSlot}
                                        classes={this.props.classes}
                                        addInProgress={this.props.addInProgress}
                                        selectedUser={this.state.selectedUserReservation}
                                        reservationToAdd={this.state.newReservation}
                                        updateReservationToAdd={this.updateReservationToAdd} />
                                    <Grid container justify="center">
                                        <this.OkIconButton />
                                    </Grid>
                                </Grid>}
                            <ReservationSlotResponse
                                classes={this.props.classes}
                                type={this.props.addInProgress ? "add" : "delete"}
                                reservationResponse={this.props.reservationResponse}
                                inProgress={this.props.addInProgress} />
                        </Grid>
                    </Grid>}
                </DialogContent >
                <DialogActions className={this.props.classes.reservationSlotDetailDialogActions}>
                    {<this.CloseIconButton />}
                </DialogActions>
            </Dialog >
        );
    }
}

export default withStyles(styles as any)(WithMediaQuery(ReservationSlotDetailDialog)) as React.ComponentType<IInnerProps>;